import React from 'react'
import { Outlet, useParams } from 'react-router-dom'

import { MyTrainingRequestsDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

const RequestDetailIndexPage = () => {
  const { id } = useParams()
  const { loading: loadingResources, data } = useQuery(MyTrainingRequestsDocument, {
    variables: { ids: [Number(id)] },
  })
  const trainingRequest = data?.trainings.trainingRequestsConnection.nodes.find(
    (tr) => tr.id == Number(id)
  )
  const seeCatalog = !!data?.trainings._policies.trainingsSeeCatalog.can

  if (loadingResources) return <></>

  return (
    <AuthorizeUser authorizeFn={() => seeCatalog}>
      <Outlet context={{ trainingRequest, loadingResources }} />
    </AuthorizeUser>
  )
}

export default RequestDetailIndexPage
